import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { Direction } from '../../../../contexts/session/Locale.js';

var getHashFromMetadata = function getHashFromMetadata(metadataContainer, getHash, language, direction, platform) {
  // Hierarchy: platform > language > direction > default
  var hash = platform && metadataContainer[platform] || metadataContainer[language] || direction === Direction.RTL && metadataContainer.rtl || metadataContainer.default;
  var hashValue = getHash(hash);
  var defaultHashValue = getHash(metadataContainer.default);
  return hashValue === 'flip' ? {
    hash: defaultHashValue,
    flip: true
  } : {
    hash: hashValue,
    flip: false
  };
};
var getAssetDataFromMetadata = function getAssetDataFromMetadata(metadata, getHash, context) {
  var _ref = context.locale ? context.locale.split('-') : ['en'],
    _ref2 = _slicedToArray(_ref, 1),
    language = _ref2[0];
  var platform = context.platform !== 'web' ? context.platform : undefined;
  return getHashFromMetadata(metadata, getHash, language, context.direction, platform);
};

export { getAssetDataFromMetadata };
//# sourceMappingURL=getAssetDataFromMetadata.js.map
